export { default as Main } from './Main';
export { default as Home } from './Home';
export { default as MyApps } from './MyApps';
export { default as Settings } from './Settings';
export { default as SettingsAddLang } from './SettingsAddLang';
export { default as Welcome } from './Welcome';
export { default as Search } from './Search';
